<template>
  <v-row>
    <v-col cols="12">
      <h2>{{ $t("commission_role.head") }}</h2>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-actions>
          <v-row no-gutters>
            <span>{{ $t("commission_role.head_list") }}  </span>

            <!-- <span style="margin-left: 20px;">
             <v-btn color="primary" class="px-5" @click="$router.push('/commissionRoleAdd')">
              <v-icon class="px-3">mdi-plus</v-icon>
              <span class="pr-3">{{ $t('commission_role.create') }} </span>
            </v-btn> -->
            <!-- </span> -->
          </v-row>
        </v-card-actions>
        <v-card-actions class="pt-0">
          <v-data-table mobile-breakpoint="0" style="width: 100%" :headers="headers" :no-data-text="$t('not_found')"
            :no-results-text="$t('not_found')" :options.sync="pagination" :server-items-length="pagination.totalItems"
            :items-per-page="pagination.rowsPerPage" :loading="loading" :page.sync="pagination.currentPage" :footer-props="{
              'items-per-page-options': [10, 25, 30, 40, 50],
            }" :items="roles">
            <template v-slot:[`item.action`]="{ item }">
              <v-btn color="primary" @click="$router.push('/commissionRoleEdit/'+item.id)" class=""> {{ $t('edit') }} </v-btn>
            </template>
          </v-data-table>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import DatePickerInput from '@/components/input/DatePickerInput.vue'
import SelectInput from '@/components/input/SelectInput.vue'
import store from '@/store'
export default {
  components: {
    DatePickerInput,
    SelectInput,
  },

  data() {
    return {
      dateFrom: moment().subtract(3, 'days').format('YY-MM-DD'),
      dateTo: moment().format('YY-MM-DD'),
      date: null,
      searchData: "",
      headers: [
        {
          text: this.$t('commission_role.header1'),
          value: 'name',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_role.header2'),
          value: 'turnover_from',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_role.header3'),
          value: 'turnover_to',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_role.header4'),
          value: 'deposit_from',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_role.header5'),
          value: 'deposit_to',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_role.header6'),
          value: 'commission_percent_bacara',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_role.header7'),
          value: 'commission_percent_slot',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_role.header8'),
          value: 'commission_percent_sport',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_role.header9'),
          value: 'commission_percent_lottery',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_role.header10'),
          value: 'cashback_percent',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_role.header11'),
          value: 'cashback_percent_lottery',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_role.header12'),
          value: 'commission_min_withdraw',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_role.header13'),
          value: 'limit_commission',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_role.header14'),
          value: 'action',
          width: '95px',
          align: 'center',
          sortable: false,
        },
      ],
      roles: [],
      loading: false,
      pagination: {
        currentPage: 1,
        rowsPerPage: 25,
        totalItems: 0,
      },
      total: 0,
      commissionMemberType:''
    }
  },
  async created() {
    this.addLogPage()
    try {
      await this.$store.dispatch('getSettingFeature').then(res => {
        this.commissionMemberType = res.filter(item => item.page === 'commissionmember')[0]?.value ;
      })
    } catch (e) {
      console.log("Load Commission Fail");
     }
    this.getCommissionRole()
  },
  watch: {
    // pagination: {
    //   async handler(newValue, oldValue) {
    //     let cont = false
    //     if (oldValue.page !== newValue.page) cont = true
    //     if (oldValue.itemsPerPage !== newValue.itemsPerPage) cont = true
    //     if (oldValue.sortBy !== newValue.sortBy) cont = true
    //     if (oldValue.sortDesc !== newValue.sortDesc) cont = true
    //     if(cont)await this.getCommissionRole()
    //   },
    //   deep: true,
    // },
  },
  methods: {
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            name: 'ตั้งค่าคอมมิชชั่น',
            url: window.location.href,
            detail: 'ตั้งค่าคอมมิชชั่น',
            admin: userSystem.name ? userSystem.name : '',
          }
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
        // if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
        //   this.$swal.fire({
        //     icon: 'error',
        //     title: e.message,
        //   })
        // }
      }
    },
    async getCommissionRole() {
      this.loading = true
      this.roles = []

      let rs = await this.$store.dispatch('getAllCommissionRole')
      this.pagination.totalItems = parseInt(rs.count);
      this.total=(rs.count)?rs.count:0;
      rs.data.forEach(element => {
        this.roles.push({
          id: element.id,
          name:element.name,
          turnover_from: element.condition_amount_from,
          turnover_to:element.condition_amount_to,
          deposit_from: element.condition_deposit_amount_from,
          deposit_to: element.condition_deposit_amount_to,
          commission_percent_bacara: (this.commissionMemberType=="all")?element.commission_percent:element.commission_percent_bacara,
          commission_percent_slot:(this.commissionMemberType=="all")?element.commission_percent:element.commission_percent_slot,
          commission_percent_sport: (this.commissionMemberType=="all")?element.commission_percent:element.commission_percent_sport,
          commission_percent_lottery: (this.commissionMemberType=="all")?element.commission_percent:element.commission_percent_lottery,
          commission_min_withdraw: element.commission_min_withdraw,
          cashback_percent: element.cashback_percent,
          cashback_percent_lottery:element.cashback_percent_lottery,
          limit_commission: element.limit_commission,
        })
      })
      this.loading = false
    },
    formatDateYYYY(date) {
      const dateConv = date?.length > 8 ? date.substring(2) : date
      return moment(`20${dateConv}`).format('YYYY-MM-DD')
    },
  },
}
</script>
